import DashShell from "@components/common/DashShell";
import CustomerForm from "@components/forms/CustomersForm/CustomerForm";
import { Crumbs, SectionBanner } from "@ucchub/ui";
import manageAccessBanner from "@img/manageAccessBanner.png";
import breadCrumbs from "@json/common/crumbs.json";
import Spacing from "@vfuk/core-spacing";
import StateNotification from "@vfuk/core-state-notification";
import Paragraph from "@vfuk/core-paragraph";

import { t } from "i18next";
import useCustomerPermissions from "@hooks/usePermission";

const NewAddCustomer = () => {
  const { permissions, isPermissionLoading } = useCustomerPermissions();
  return (
    <DashShell>
      <>
        <Crumbs items={breadCrumbs.add_Customers} />
        <SectionBanner
          heading={t("core:customers:banner.heading")}
          subtitle={t("core:customers:banner.sub_title") || undefined}
          image={manageAccessBanner}
          iconName={t("core:customers:banner.icon_name") || undefined}
        />
      </>
      {!isPermissionLoading && permissions?.manageCustomers ? (
        <CustomerForm />
      ) : (
        !isPermissionLoading && (
          <Spacing spacingLevel={{ top: 4 }}>
            <StateNotification state="error">
              <Paragraph>{t("core:customers:error_message")}</Paragraph>
            </StateNotification>
          </Spacing>
        )
      )}
    </DashShell>
  );
};

export default NewAddCustomer;
